"use client";

import { useAppSelector } from "@/store/hooks";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function RecaptchaProvider({ children }: RecaptchaProviderProps) {
  const recaptchaKey = useAppSelector((state) => state.config.googleRecaptchaV3);
  if (recaptchaKey) {
    return <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>{children}</GoogleReCaptchaProvider>;
  } else {
    return <>{children}</>;
  }
}
type RecaptchaProviderProps = {
  children: React.ReactNode;
};
